import { Directive, ElementRef, forwardRef, HostListener, Input, OnChanges } from '@angular/core';
import {MAT_INPUT_VALUE_ACCESSOR} from '@angular/material/input';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import { formatNumber } from '@angular/common';

@Directive({
  selector: 'input[thousand-swiz]',
  providers: [
    {provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: ThousandSeperatorDirective},
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ThousandSeperatorDirective),
      multi: true,
    }
  ]
})
export class ThousandSeperatorDirective {
  private _value: string | null;
  decimalMarker;
  locale = 'en';
  @Input('numberPrefix') numberPrefix="";
  // @Input('thousand-swiz') thousandSwiz = false;
  @Input('numberSuffix') numberSuffix="";
  // @Input('minFraction') minFraction=2;

  constructor(private elementRef: ElementRef<HTMLInputElement>,
  ) {
    
  }

  ngOnChanges(){
    // console.log(this.thousandSwiz,'thousdswiz');
  }

  get value(): string | null {
    return this._value;
  }

  @Input('value')
  set value(value: string | null) {
    this._value = value;
    // if(this.thousandSwiz) {
    //   console.log(this._value, 'comimg');
      
      this.formatValue(value);
    // }
  }

  
  isLastCharacterDecimalSeparator(value: any) {
    // console.log(value, 'comimg1');
    return isNaN(parseFloat(value[value.length - 1]));
  }
  isFirstCharacterDecimalSeparator(value: any) {
    // console.log(value, 'comimg2');
    return isNaN(parseFloat(value[0])) && value[0] != '-';
  }

  
  private formatValue(value: string | null) {
    if (value === null || value === '' || value === undefined) {
      this.elementRef.nativeElement.value = '';
      return;
    }

    value = value.toString();

    if (this.isFirstCharacterDecimalSeparator(value)) {
        this.elementRef.nativeElement.value = "";
        return;
    }

    if(this.isLastCharacterDecimalSeparator(value)) {
      return;
    }

    
    // if(this.minFraction > 0) {
    //   const [integer, decimal] = value.split('.');
    //   if(!decimal || (decimal && decimal.length < this.minFraction && (decimal[0]!=''))) {
        
    //     let val = parseFloat(value)
    //     value = val.toFixed(this.minFraction).toString();
    //   }
    // }

    // Conclude the decimal and thousand separators from locale
    const [thousandSeparator, decimalMarker] = formatNumber(1000.99, this.locale).replace(/\d/g, '');
    this.decimalMarker = decimalMarker;

    //Here value should always come with . as decimal marker thus any other behavior is bug
    const [integer, decimal] = value.split('.');

    //Group every three elements, and add thousandSeparator after them
    
    this.elementRef.nativeElement.value = this.numberPrefix + integer.replace(/\B(?=(\d{3})+(?!\d))/g, '\'');

    //Add decimals and decimalMarker if any
    if (decimal) {
      this.elementRef.nativeElement.value = this.elementRef.nativeElement.value.concat(decimalMarker, decimal);
    }
    this.elementRef.nativeElement.value = this.elementRef.nativeElement.value.concat(this.numberSuffix);
  }

  private formatValue1(value: string | null) {
    if (value === null) {
        this.elementRef.nativeElement.value = '';
    } else {
        this.elementRef.nativeElement.value = 'test'+ value;
    }
  }

  private unFormatValue() {
    const value = this.elementRef.nativeElement.value;
    this._value = value.replace(/[^\d.-]/g, '');
    if (value) {
      // const [integer, decimal] = this._value.split('.');
      // if(decimal && decimal.length > 0 && parseInt(decimal) == 0) {
      //   this._value = integer;
      // }
      this.elementRef.nativeElement.value = this._value;
    } else {
      this.elementRef.nativeElement.value = '';
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value) {
    // if(this.thousandSwiz) {
      this._value = value.replace(/[^\d.-]/g, '');
      this._onChange(this._value); // here to notify Angular Validators
    // }
  }

  @HostListener('blur')
  _onBlur() {
    // if(this.thousandSwiz) {
      this.formatValue(this._value);
    // }
  }

  @HostListener('focus')
  onFocus() {
    // if(this.thousandSwiz) {
      this.unFormatValue();
    // }
  }

  _onChange(value: any): void {
  }

  writeValue(value: any) {
    this._value = value;
    this.formatValue(this._value); // format Value
  }

  registerOnChange(fn: (value: any) => void) {
    this._onChange = fn;
  }

  registerOnTouched() {
  }

}
